import Swiper, { Lazy, Navigation } from 'swiper';

const swiperEl = '.js-card-carousel-swiper';
const btnPrevEl = '.js-card-carousel-prev';
const btnNextEl = '.js-card-carousel-next';

/**
 * slide preloader class
 * @type {string}
 */
const slidePreloaderClass = 'c-slide-preloader';

const swipers = [];

/**
 * @param carousel
 * @param prev
 * @param next
 * @returns {boolean}
 */
function initCarousel(carousel, prev, next) {
  const swiper = new Swiper(carousel, {
    loop: false,
    init: false,
    slidesPerView: 3,
    speed: 700,
    modules: [Lazy, Navigation],
    lazy: {
      loadPrevNext: true,
      preloaderClass: slidePreloaderClass,
      preloadImages: false,
    },
    navigation: {
      prevEl: prev,
      nextEl: next,
    },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });

  swiper.init();
  swipers.push(swiper);

  return true;
}

const carousels = window.document.querySelectorAll(swiperEl);
if (carousels.length) {
  carousels.forEach((item) => {
    window.document.addEventListener('DOMContentLoaded', () => {
      initCarousel(item, btnPrevEl, btnNextEl);
    });
  });
}
